export default {
  message: {
    "strid1": "HALAMAN UTAMA",
    "strid2": "TENTANG MLBB",
    "strid3": "ESPORTS",
    "strid4": "KOMUNITAS",
    "strid5": "BAHASA",
    "strid6": "SEMUA ORANG DAPAT MENJADI LEGENDA",
    "strid7": "VIDEO",
    "strid8": "LAINNYA",
    "strid9": "Privacy Policy",
    "strid10": "Terms of Service",
    "strid11": "© MOONTON Corporation.All rights reserved.",
    "strid12": "OVERVIEW GLOBAL",
    "strid13": "GALERI",
    "strid14": "KARYA FANS",
    "strid15": "INFLUENCER",
    "strid16": "AYO BERGABUNG DENGAN MLBB CREATOR CAMP",
  }
}